import { memo } from 'react';
import { I18n } from 'src/modules/common/components/I18n/I18n';
import { MESSAGES } from 'src/modules/common/constants';

type Props = {
    qty: number;
}

export const PipeConnectorQuantity = memo(({ qty }: Props) => (
    <div className="vss-pipe-connector-quantity">
        <I18n messageId={MESSAGES.quantityShorthand}/>

        <span className="vss-pipe-connector-quantity__value">{qty}</span>
    </div>
));
